import { useCallback } from "react";

/**
 * Returns a callback for AntD getPopupContainer.
 * It will attach the popup to the given containerId
 * if the triggerNode is inside it, otherwise fallback to body.
 */
export const usePopupParent = (containerId: string = "full-screen") => {
  return useCallback((triggerNode?: HTMLElement) => {
    const container = document.getElementById(containerId);

    // If trigger is inside the container, use it
    if (container && triggerNode && container.contains(triggerNode)) {
      return container;
    }

    // Otherwise fallback to body
    return document.body;
  }, [containerId]);
};
